// components/VoiceRecorder.jsx
import React, { useEffect, useRef, useState } from 'react';
import { Mic } from '@mui/icons-material';

const VoiceRecorder = ({ onTranscript, provider }) => {
    const [isListening, setIsListening] = useState(false);
    const recognitionRef = useRef(null);

    const name = sessionStorage.getItem("name").toString();

    useEffect(() => {
        if ('webkitSpeechRecognition' in window) {
            const SpeechRecognition = window.webkitSpeechRecognition;
            recognitionRef.current = new SpeechRecognition();
            recognitionRef.current.continuous = false;
            recognitionRef.current.interimResults = false;
            recognitionRef.current.lang = 'en-US';

            recognitionRef.current.onresult = (event) => {
                const transcript = event?.results[0][0]?.transcript;
                onTranscript(transcript);
            };

            recognitionRef.current.onerror = (event) => {
                console.error("Speech recognition error", event?.error);
                setIsListening(false);
            };

            recognitionRef.current.onend = () => {
                setIsListening(false);
            };
        }
    }, [onTranscript]);

    const handleSpeechToText = () => {
        if (isListening) {
            recognitionRef.current.stop();
            setIsListening(false);
        } else {
            recognitionRef.current.start();
            setIsListening(true);
        }
    };

    return (
        <div className="voice-modal-overlay" onClick={() => !isListening && onTranscript(null)}>
            <div className="voice-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="voice-modal-header">
                    <h2>{name}</h2>
                    <p>Don't know which {provider} to search for or need?</p>
                </div>

                <div className="voice-button-container">
                    <button
                        className={`voice-button ${isListening ? 'listening' : ''}`}
                        onClick={handleSpeechToText}
                        disabled={isListening}
                    >
                        <Mic className="voice-mic-icon" />
                        {isListening && <div className="pulse-ring"></div>}
                    </button>
                </div>

                <div className="voice-instructions">
                    <p>
                        {isListening
                            ? "Listening... Please speak now"
                            : "Tap the audio button and explain what your needs are."
                        }
                    </p>
                </div>
            </div>
        </div>
    );
};

export default VoiceRecorder;
